import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

export const Section = styled.div`
   display: flex;
   flex-direction: column;
   flex-shrink: 0;
   border: ${tokens.border.thin} ${theme.colors.border.default};
   border-radius: ${tokens.radius.md};
   overflow: hidden;
`;

export const SectionHeader = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: ${tokens.space.sm} ${tokens.space.md};
   background-color: ${theme.colors.bg.tertiary};
   border-bottom: ${tokens.border.thin} ${theme.colors.border.subtle};
`;

export const ScrollArea = styled.div<{ $maxHeight?: string }>`
   overflow: auto;
   max-height: ${({ $maxHeight }) => $maxHeight ?? '240px'};
`;

export const Divider = styled.hr`
   border: none;
   border-top: ${tokens.border.thin} ${theme.colors.border.subtle};
   margin: 0;
`;

export const ActionFooter = styled.div`
   display: flex;
   flex-shrink: 0;
   justify-content: flex-end;
   gap: ${tokens.space.md};
   padding-top: ${tokens.space.md};
   border-top: ${tokens.border.thin} ${theme.colors.border.default};
`;

export const CheckboxTh = styled.th`
   width: 0;
   white-space: nowrap;
   text-align: center;
   padding-left: ${tokens.space.md} !important;
   padding-right: ${tokens.space.md} !important;
`;

export const CheckboxTd = styled.td`
   text-align: center;
   vertical-align: middle;
   padding-left: ${tokens.space.md} !important;
   padding-right: ${tokens.space.md} !important;
`;
